<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="editMode()">{{ t('common.labels.billing') }} <strong>{{ package.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
            <app-billing-basedata *ngIf="editMode()" [package]="package" (setEdit)="setEdit($event)"></app-billing-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
